export interface Activityfeedpost {
    id: number;
    user_id: number;
    action: string;
    categorie: string;
    section: string;
    type: string;
    url: string;
    notes?: string;
    date_time?: string;
    verb_id?: number;
    entity_id?: number;
    module_id?: number;
    target_id?: number;
    slug_id?: string;
    metadata?: Record<string, any> | string;
    description: string;
    due_time_end: string;
    due_time_start: string;
    due_date_end: string;
    due_date_start: string;
    title: string;
    user_first_name: string;
    user_last_name: string;
    user_slug: string;
  }
  
  export function createEmptyActivityfeedpost(): Activityfeedpost {
    return {
      id: 0,
      user_id: 0,
      action: '',
      categorie: '',
      section: '',
      type: '',
      url: '',
      description: '',
      due_time_end: '',
      due_time_start: '',
      due_date_end: '',
      due_date_start: '',
      title: '',
      user_first_name: '',
      user_last_name: '',
      user_slug: ''
    };
  }